import { useContext } from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';
import Api from '../../services/ApiService';
import ModalContext from '../modal/ModalContext';
import toastr from '../toastr';

const DocumentEmail = ({ documentId, emailData = {} }) => {
  // cast to array
  const to = Array.isArray(emailData.to) ? emailData.to : [emailData.to];

  // Remove bad emails
  const filteredTo = to.filter(addy => {
    if (!addy) {
      return false;
    }

    return true;
  });

  const { close } = useContext(ModalContext);

  const layout = [
    {
      name: 'custEmail',
      label: 'Customer Email(s)',
      control: 'Tags',
      type: 'email',
      required: true,
      data: filteredTo,
      minListSize: 1,
      helpText: '[Tab] after each entry',
    },
  ];

  const sendMail = payload => {
    const { subject, attachments = [], html, filePath, signed } = emailData;

    const recipients = payload[0].data;

    const body = {
      to: recipients,
      subject,
      html,
      attachments,
      filePath,
      signed,
    };

    return Api.post('archive/email', body)
      .then(() => {
        const subject = documentId ? `Document ${documentId} Sent` : 'Document Sent';
        toastr.success(subject, `To ${recipients.join(', ')}`);
        close();
      })
      .catch(err => {
        console.error(err);
        toastr.error('Something went wrong');
      });
  };

  return <Form layout={layout} onCancel={close} submit={sendMail} feedback="none" hideReset submitAll resetOnSubmit />;
};

DocumentEmail.propTypes = {
  emailData: PropTypes.object,
  close: PropTypes.func,
};

export default DocumentEmail;
